import React, { useRef } from "react";
import { List, ListItem, Region, report_def, Section, SubReport, TableCell } from "../core/pdf/types";
import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";
import { closest, closestKey } from "../core/utils/dom";
import { HeaderFooterEditor } from "./HeaderFooterEditor";
import { ContentItems } from "./ContentItems";
import { toMillimeters, toPdfPoint } from "../core/pdf/utils";
import { Icon } from "../core/ui/icons";
import { useConditional } from "../core/hooks/useConditional";
import { Modal } from "../core/ui/Modal";
import { useApi } from "../core/hooks/useApi";
import { api } from "../api/api";
import { Table } from "../core/ui/Table";

export function SubReportEditor(props: {
	subReport: SubReport,
	embedded: boolean,
}) {

	const designer = useDesigner();

	const subReport = props.subReport;

	let style: any = {};
	style.width = "210mm";
	style.position = "relative";
	
	const elementContext = useElementContext(subReport);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	let name;
	if (subReport.report && subReport.report.title) {
		name = <div className="tag">{subReport.report.title + " (" + subReport.report.def + ")"}</div>;
	} else {
		name = <i>Not Selected</i>;
	}


	return (
		<ElementContext.Provider value={elementContext}>
			<div
				className={"sub-report content-element " + state.classes + (props.embedded ? " embedded" : "")}
				data-key={subReport.id}
				id={state.elementID}

				style={style}

				onClick={(e) => {
					designer.setFocus(subReport);
				}}				
			>

				<div className="flex horiz align-center gap-5 padding-5">
					<Icon type="document" size="normal" />
					<div className="flex horiz gap-5 align-center">
						<b className="text-brand-primary">Sub Report</b>
						{name}
						<ChooseSubReport
							onChange={(report) => {
								subReport.report = report;
								designer.refreshItem(subReport);
							}}
						/>
					</div>
				</div>

				{/* <ContentItems
					content={section.content}
				/> */}

			</div>
		</ElementContext.Provider>
	);
}

export function ChooseSubReport(props: {
	onChange: (report: {
		def: string,
		title: string,
	}) => void,
}) {

	const reports = useApi({
		request: () => api.report_def_get_all(),
		prepareResult(result) {
			result.sort((a: any, b: any) => {
				return a.title.localeCompare(b.title);
			});
			return result;
		},
	}, []) as report_def[];

	const modal = useConditional(() => {

		return (
			<Modal
				title="Choose Sub Report"
				showSave={false}
				onCancel={modal.close}
				size="width-50vw"
			>

				<Table
					cols={[
						"ID",
						"Title",
					]}
					items={reports ? reports : []}
					render={{
						colTitle: (c) => c,
						colValue: (r, c) => {
							if (c === "ID") {
								return r.id;
							} else {
								return r.title;
							}
						}
					}}
					interactive={true}
					onClick={(e, r) => {
						props.onChange({
							def: r.id,
							title: r.title,
						})
						modal.close();
					}}
				/>

			</Modal>
		);
	});

	return (
		<>
			<button
				className="primary"
				onClick={() => {
					modal.show({});
				}}
			>Change</button>
			{modal.render()}
		</>
	)
}